export const locale = {
    lang: 'de',
    data: {
      'DISPATCH': {
        'ENCUESTA_PILOTO': 'Pilotumfrage',
        'ENCUESTA_PILOTO_ENVIO': 'Pilotumfrage senden',
        'ENCUESTA_LANZAMIENTO':'Startbestätigung',
        'BTN_COPY':'Umfrageschlüssel kopieren',
        ////*******Tab Crear Encuestas********************************///
        'CREAR_ENCUESTA':'Umfrage erstellen',
        'ENCUESTA_DEMO':'Umfrage vorschlagen',
        'BOTON_CREAR_ENCUESTA':'Umfrage generieren',
        'STEP': 'Schritt abgeschlossen',
        'SEE_TI': 'Technische Anforderungen anzeigen',
        'CLAVE': 'Zugangsschlüssel',
        'ACCESO': 'Schlüssel',
        'NOFECHA':'Sie können diese Aktion nicht durchführen, da es noch kein Startdatum gibt',
        'LABEL01': 'Kopieren Sie den Zugangsschlüssel, und fügen Sie ihn in die Pilotumfrage ein',
        'LABEL02': 'Der Versand der Umfrage wurde bestätigt',
        'LABEL03': 'E-Mail',
        'LABEL04': 'Versenden der Pilotumfrage',
        'LABEL05': 'Etwas geht schief',
        'LABEL06': 'Die Pilotumfrage wurde korrekt verschickt',
        'LABEL07': 'Erforderliches Feld',
        'LABEL08': 'Schritt abschließen',
        'LABEL09': 'Umfrage-Demo-Benutzer wurden erschöpft',
        'CONFIRMAR_ENVIO': 'Bestätigen Sie das Senden von E-Mails',
        'DES_CONFIRMAR_ENVIO': 'Versand von E-Mails nicht bestätigen',
        'CONFIRMAR_ENVIO_35': 'Versand von Umfrageeinladungen bestätigen',
        'SI_CONFIRMAR_ENVIO': 'Ja',
        'NO_CONFIRMAR_ENVIO': 'Nein',
        'CHANGE-OPTIONS':'Mail-Optionen ändern',
        'NO_ENVIO_CORREO':'Es wird keine Mail gesendet',
        'SI_ENVIO_CORREO':'Die Mails werden gesendet',
        'EN_CASO':'Durch Auswahl von NEIN soll die gesamte Kommunikation über die Umfrage außerhalb der Plattform abgewickelt werden. Es werden keine E-Mails an die Benutzer gesendet.',
        'AUTOLOG_35':'Link für Umfrage-Auto-Login:',
        'TITULO':'In diesem Abschnitt können Sie einen Testlauf der Umfrage durchführen:',
        'LINK':'1. Rufen Sie den folgenden Link auf:',
        'LINKNORMA35':'1. Greifen Sie auf den folgenden Link für die Umfrage zu:',
        'CLAVE_ENCUESTA':'2. Kopieren Sie diesen Testschlüssel:',
        'INSTRUCCION3':'3. Fügen Sie den Schlüssel in die Passwort-Zelle ein.',
        'INSTRUCCION4':'4. Klicken Sie auf Login',
        'TEXTO_CONFIRMAR':'Bestätigen Sie, dass die Kommunikation mit den Benutzern (Einladung und Erinnerungen) per E-Mail erfolgen soll',
        'TEXTO_CONFIRMAR2':'WENN SIE NICHT WOLLEN, dass die Mails versendet werden, überspringen Sie einfach das Anklicken und schließen Sie den Schritt.',
        'TITULO_PILOTO':'In diesem Abschnitt können Sie die Einladungsmail zur Teilnahme an bis zu fünf verschiedene Mitarbeiter senden, um den Empfang der Mail und die Visualisierung der Umfrage zu testen, bevor Sie die Umfrage wirklich starten:',
        'INSTRUCCION_PILOTO':'1. Geben Sie die E-Mails ein und wählen Sie die Sprache, in der Sie die Einladung erhalten möchten',
        'INSTRUCCION_PILOTO2':'2. Klicken Sie auf die Schaltfläche Senden',
        'SELLANG':'Wählen Sie eine Sprache',
        'MENSAJES':{
           'MSN_INGR_COD':'<span> Um zu bestätigen, dass keine Einladungs- oder Erinnerungs-E-Mails gesendet werden, geben Sie den Code in Rot in das Textfeld ',
           'MSN_INGR_COD2':'</span>',
           'MSN_CHANGE-CONFI':'Die Konfiguration wurde geändert',

        'BTN_MODALES':{
          'CONFIRM': 'Bestätigen',
          'EXIT': 'Exit',
        }
        },
        'URL35':{ // Sive unicamente para dispatch de la norma 35
            'MAS50':'mehr 50',
            'MENOS50':'weniger 50',
            'CORTA': 'Allgemeine URL',
        },

        'CERTIFICAR2':{ // Sive unicamente para crear encuesta de certificar 2.0
          'LINK':'1. Rufen Sie den folgenden Link auf:',
          'CLAVE_ENCUESTA':'2. Kopieren Sie einen der im Abschnitt "Demo-Benutzer" generierten Schlüssel',
          'INSTRUCCION3':'3. Fügen Sie den Schlüssel in die Passwort-Zelle ein',
          'INSTRUCCION4':'4. Klicken Sie auf Login',
          'USERSDEMO':'Demo-Benutzer',
          'USERS':'Benutzer',
          'CLAVE':'Schlüssel',
          'ESTATUS':'Status',
          'ESTATUS-USER-ASIGNA':'Zugewiesen',
          'INST_UPD_URL_NAME':'Passen Sie die ShortUrl an, indem Sie einen Text mit bis zu 6 Zeichen eingeben, der Ihren Benutzern vertraut ist.',
          'BTN_UPD_GUARDA':'Speichern',
          'BTN_UPD_CAN':'Abbrechen',
          'CUS_SHOI_URL':'Umfrage-URL anpassen',
          'MODAL_ACTU_CUS_SHOI_URL':'Aktualisieren des Namens in der URL',
          'ACTU_CUS_SHOI_URL_OK':'Der Name in der Url wurde korrekt aktualisiert',
          'ACTU_CUS_SHOI_URL_FALSE':'Der Name in der Url existiert bereits',

        },


        'ALERT':{
            'HEADER':'Info',
            'MESSAGE_CON': '¿Sollen Sie den Versand von E-Mails an Benutzer bestätigen?',
            'MESSAGE': '¿Sie möchten den Versand von E-Mails an Ihre Mitarbeiter bestätigen?',
            'MESSAGE_DESCON': '¿Sie möchten den Versand von E-Mails an Benutzer nicht bestätigen?',
            'BTN_CANCEL': 'Nein, abbrechen',
            'BTN_CONFIRM': 'Ok, senden',
            'BTN_NO_CONFIRM': 'Nein, senden',
            'BTN_SI_CONFIRM': 'Ja, senden',
            'BTN_NO_CANCEL': 'Abbrechen',
            'BTN_OK': 'Ok',
            'ERROR_01':'Sie haben noch keine Einladung gesendet',
            'SINCOLABS': 'Sie können die Umfrageeinladung noch nicht versenden, Sie müssen vorher die Teilnehmerliste der Firma hochladen',
            'SINLANG': 'Sie haben noch keine Sprache für eine oder mehrere eingegebene E-Mail-Adressen ausgewählt',
            'ERRMAIL': 'Die eingegebene E-Mail hat nicht die richtige Syntax, überprüfen Sie sie und geben Sie sie erneut ein'
        }
      },
    'PULSE':{
            'LABEL01': 'Senden Sie die Umfrage an Ihre Mitarbeiter',
    }
    }
};
